<template>
	<div v-if="dialogVisible">
		
	  <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" :width="!nametitle?'56%': '20%'" :top="nametitle?'32vh':'15vh'" :title="!nametitle?'设置投放画面':''">
		<div class="txt-center">
			<div v-if="!nametitle" class="yjtf">
				<div class="dis-flex">
					<el-upload
					:before-upload="beforeUpload"
						:show-file-list="false"
						:on-success="onAllSuccess"
						:action="action"
						list-type="picture-card">
						<!-- <i  class="el-icon-plus"></i> -->
						一键投放所有
					 </el-upload>
					 <el-upload
					 :before-upload="beforeUpload"
						style="margin: 0 30px;"
					 	:show-file-list="false"
					 	:on-success="onZSuccess"
					 	:action="action"
					 	list-type="picture-card">
					 	<!-- <i  class="el-icon-plus"></i> -->
					 	一键投放正面
					  </el-upload>
					  <el-upload
					  :before-upload="beforeUpload"
					  	:show-file-list="false"
					  	:on-success="onFllSuccess"
					  	:action="action"
					  	list-type="picture-card">
					  	<!-- <i  class="el-icon-plus"></i> -->
					  	一键投放反面
					   </el-upload>
				</div>
			</div>
		  <div style="margin-bottom: 10px;" v-if="nametitle == '价审'">
			  订单金额：<span class="mColor" style="font-size: 16px;">￥{{price}}</span>
		  </div>
		  <div v-if="nametitle">是否{{nametitle}}？</div>
		  <div v-else style="margin-top: 20px;" class="dis-flex jus-aron b-box">
			 <div v-for="(item,index) in imgarr" :key="'imgs'+index" >
				 <div class="imgbox" @click="clickImg(index)">
					 <!-- <img src="../../../assets/logo1.png" > -->
				  	<!-- <el-upload
					   :class="{uoloadSty:item.urlObj.length == 1?true:false,disUoloadSty:item.urlObj.length == 1?true:false}"
						:on-success="onSuccess"
						:action="action"
						:limit="1"
						:file-list="item.urlObj"
						:multiple="false"
						list-type="picture-card"
						:on-remove="handleRemove">
						<i class="el-icon-plus"></i>
				  	 </el-upload> -->
					 
					 <el-upload
					 :show-file-list="false"
					 	:on-success="onSuccess"
					 	:action="action"
					 	list-type="picture-card">
						<img v-if="item.url" :src="item.url" class="avatar" style="border-radius: 6px;width: 100%;height: 100%;border: 1px dashed #c0ccda;">
					 	<i v-else class="el-icon-plus"></i>
					  </el-upload>
				  </div>
				 
				  <div id="">
					 <div>{{item.text}}</div>
					 <div style="color: #0079ea;">({{item.type == 0 ? '正面':'反面'}})</div>
				  </div>
			 </div>
		  </div>
		</div>
		<span slot="footer" class="dialog-footer">
		  <el-button class="small-btn btn-bor" size="small" @click="dialogVisible = false"
			>取 消</el-button
		  >
		  <el-button
			class="small-btn bgC"
			size="small"
			type="primary"
			@click="submit"
			>确 定</el-button
		  >
		</span>
	  </el-dialog>
  </div>
</template>

<script>
	import * as imageConversion from 'image-conversion'
export default {
  props: {
	  action: {
	    type: String,
	    default() {
	      return '';
	    },
	  },
	  nametitle: {
	    type: String,
	    default() {
	      return '';
	    },
	  },
  },
  watch:{
	  imgObj(v,v2){
		  console.log(v,v2);
	  }
  },
  data() {
    return {
		price:'',
		showBtnDealImg:true,
	  noneBtnImg:false,
      dialogVisible: false,
	  index:'',
	  imgObj:{
		  fileList:[]
	  },
	  imgarr:[],
	  imgId:[]
    };
  },
  mounted() {
	  
  },
  methods: {
	  beforeUpload(file){
		  return new Promise((resolve, reject) => {
		  	imageConversion.compress(file,0.8).then(res => { 
		  	  console.log(file);
		  	  resolve(res)
		  	})
		})
	  	// return new Promise((resolve, reject) => {
	  	// 	let isLt2M = file.size / 1024 / 1024 < 4 // 判定图片大小是否小于4MB
	  	// 	console.log(isLt2M);
	  	// 	if (isLt2M) {
	  	// 	   resolve(file)
	  	// 	}else{
	  	// 		// console.log(file) // 压缩到400KB,这里的400就是要压缩的大小,可自定义
	  	// 		imageConversion.compressAccurately(file, 400).then(res => { // console.log(res)
	  	// 		  console.log(file);
	  	// 		  resolve(res)
	  	// 		})
	  	// 	}
	  	// })
	  },
	  // 一键投放
	  onAllSuccess(response, file, fileList){
		  console.log(file);
		  this.imgarr.forEach((v,k)=>{
			  let zimg = this.imgarr[k];
			  zimg.url = file.response.data.url;
			  zimg.uid = file.response.data.id
			  // this.imgObj.fileList[k].uid = file.response.data.id
			  // this.imgObj.fileList[k].url = zimg
			  this.$set(this.imgarr,k,zimg);
			  this.$set(this.imgObj.fileList,k,zimg);
		  })
	  },
	  //一键投放正面
	  onZSuccess(response, file, fileList){
		  this.imgarr.forEach((v,k)=>{
			  if( k%2 == 0){
				  let zimg = this.imgarr[k];
				  zimg.url = file.response.data.url;
				  zimg.uid = file.response.data.id
				  // this.imgObj.fileList[k].uid = file.response.data.id
				  // this.imgObj.fileList[k].url = zimg
				  this.$set(this.imgarr,k,zimg);
				  this.$set(this.imgObj.fileList,k,zimg);
			  }
		  })
	  },
	  //一键投放反面
	  onFllSuccess(response, file, fileList){
		  this.imgarr.forEach((v,k)=>{
			  if( k%2 != 0){
				  let zimg = this.imgarr[k];
				  zimg.url = file.response.data.url;
				  zimg.uid = file.response.data.id
				  // this.imgObj.fileList[k].uid = file.response.data.id
				  // this.imgObj.fileList[k].url = zimg
				  this.$set(this.imgarr,k,zimg);
				  this.$set(this.imgObj.fileList,k,zimg);
			  }
		  })
	  },
	 clickImg(index){
		// console.log(index); 
		this.index = index;
	 },
	  onSuccess(response, file, fileList){
		  console.log(file);
		  // console.log(fileList);
		  // let imgObj = this.imgarr;
		  // imgObj[this.index].url = fileList[0].response.data.url
		  // this.imgarr = imgObj
		  let zimg = this.imgarr[this.index];
		  // console.log(zimg);
		  zimg.url = file.response.data.url;
		  this.imgObj.fileList[this.index].uid = file.response.data.id
		  this.$set(this.imgarr,this.index,zimg);
		  // console.log(this.imgarr);
		  
		  // this.imgObj.fileList[this.index].urlObj = [{url:fileList[0].response.data.url}]
		  // this.$set(this.imgObj.fileList,this.index,[{urlObj:[{url:fileList[0].response.data.url}]}]);
		  // this.noneBtnImg = this.imgObj.fileList.length >= 1;
		  // console.log(this.imgObj.fileList);
	  },
	  handleRemove(response, file, fileList){
		  this.imgarr.splice(1,1)
		   // this.imgObj.urlObj = []
		  this.noneBtnImg = this.imgObj.fileList.length >= 1;
	  },
    //   提交按钮
    submit() {
      if(this.nametitle){
		  this.$emit("onjssw");
	  }else{
		  this.imgId = []
		  this.imgObj.fileList.forEach((v,k)=>{
			  // if(v.uid){
				  let obj = {
					  id:v.uid || 0,
					  type: k % 2 == 0 ? 0 : 1
				  }
				  this.imgId.push(obj)
			  // }else{
				 //  this.imgId.push('')
			  // }
		  })
		  this.$confirm('确认投放画面？', '提示').then(() => {
			  console.log(this.imgId);
			  this.$emit("onjssw", this.imgId);
		  }).catch(()=>{})
		  // console.log(this.imgId);
	  }
    },
  },
};
</script>

<style lang="scss">
	// .imgbox /deep/{
	// 	.uoloadSty .el-upload--picture-card{
	// 	  width:110px;
	// 	  height:110px;
	// 	  line-height:110px;
	// 	}
	// 	.disUoloadSty .el-upload--picture-card{
	// 	  display:none;   /* 上传按钮隐藏 */
	// 	}
	// }
.yjtf{
	text-align: left;
	padding-left: 20px;
	font-size: 18px;
	color: #0079ea;
	.el-upload--picture-card{
		width: auto;
		height: auto;
		line-height:normal;
		border: none;
	}
}
.yjtf:hover{
	cursor: pointer;
}
.b-box{
	flex-wrap: wrap;
}
.title {
  text-align: left;
}
.el-form-item__label {
  padding: 0 !important;
}
.el-form-item {
  margin-bottom: 0 !important;
  padding: 5px 30px;
}
.el-dialog__body {
  padding-top: 10px;
}
.el-dialog {
  border-radius: 8px;
}
.el-dialog__footer {
  padding-top: 0;
  text-align: center;
}
.small-btn:hover {
  opacity: 0.8 !important;
}
.small-btn:active {
  opacity: 0.9 !important;
}
</style>